module.exports = __webpack_public_path__ + "static/media/Moose.svg";